import { useSession } from '@airship-platform/airship-auth';
import { NavBar as BaseNavBar } from '@airship-platform/jam-web/components';
import { useScreen } from '@airship-platform/jam-web/hooks';
import { CloseIcon } from '@airship-platform/jam-web/icons';
import OrganizationLogo from '../assets/OrganizationLogo';
import { useNavContext } from './NavbarContext';

type NavbarProps = {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
};

const NavBar: React.FC<NavbarProps> = ({ isOpen, setIsOpen }) => {
  const { navbarBody, footerNode } = useNavContext();
  const { claims } = useSession();
  const { isMobile } = useScreen();

  return (
    <BaseNavBar
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      isMobile={isMobile}
      navbarBody={navbarBody}
      footerNode={footerNode}
      closeIcon={<CloseIcon onClick={() => setIsOpen(false)} />}
      logo={
        <OrganizationLogo
          logoParams={{ organizationId: claims?.organizationId }}
        />
      }
    />
  );
};

export default NavBar;
